'use strict';

var updateDate = require('./updateDate');

function advanceDate(d, unit, num, reset) {
  var set = {};
  set[unit] = num;
  return updateDate(d, set, reset, 1);
}

module.exports = advanceDate;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/internal/advanceDate.js
// module id = 38
// module chunks = 1